import { FC } from 'react';
import { useTheme } from '@mui/material';
import Icon from '@mdi/react';
import { mdiHeart, mdiHeartOutline } from '@mdi/js';

interface HeartIconProps {
  /** If true, render filled heart; otherwise only border */
  filled: boolean;
  size?: number;
}

/**
 * Heart icon with layered border (darker) and fill (lighter) to reduce pixelation.
 */
const HeartIcon: FC<HeartIconProps> = ({ filled, size = 24 }) => {
  const theme = useTheme();
  const color = filled
    ? theme.palette.error.main
    : theme.palette.error.dark;
  const path = filled ? mdiHeart : mdiHeartOutline;
  return (
    <Icon
      path={path}
      size={`${size}px`}
      color={color}
    />
  );
};

export default HeartIcon;